export default "__VITE_ASSET___ovxS90a__"